module.exports = __webpack_public_path__ + "media/images/flags/64/Netherlands-Antilles-cc413fda2ca60117ea04b5cd967278cd.png";